export default __webpack_public_path__ + "9b0b7d9b37962e5da3d345a7e1e6bb48.jpg";